/* SLP email band: subscribes an address to a Klaviyo list without leaving the page.
   Attaches to every [data-slp-email-form]; the form carries the list ID in a hidden "g" input and the
   messages in data-slp-success / data-slp-error. The message element is the next [data-slp-email-message].
   If the request cannot be made, the form falls back to its normal submit (Klaviyo's page in a new tab).
   Each form binds once, guarded by data-slp-init. */
(function () {
  'use strict';

  var ENDPOINT = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

  function setup(form) {
    if (form.hasAttribute('data-slp-init')) return;
    form.setAttribute('data-slp-init', '');

    var message = form.parentElement.querySelector('[data-slp-email-message]');
    var button = form.querySelector('button[type="submit"]');

    function show(text, isError) {
      if (!message) return;
      message.textContent = text;
      message.classList.toggle('slp-email-band__message--error', !!isError);
      message.hidden = false;
    }

    form.addEventListener('submit', function (event) {
      if (!window.fetch || !form.checkValidity()) return;
      event.preventDefault();

      var list = form.querySelector('input[name="g"]').value;
      var email = form.querySelector('input[name="email"]').value;
      var body = 'g=' + encodeURIComponent(list) + '&email=' + encodeURIComponent(email);
      if (button) button.disabled = true;

      window.fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data && data.success) {
          show(form.getAttribute('data-slp-success'), false);
          form.reset();
        } else {
          show(form.getAttribute('data-slp-error'), true);
        }
      }).catch(function () {
        show(form.getAttribute('data-slp-error'), true);
      }).then(function () {
        if (button) button.disabled = false;
      });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-slp-email-form]'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
